// extracted by mini-css-extract-plugin
export default {"root":"p6Bu6","variant-subscriptions":"_2M6uy","variantSubscriptions":"_2M6uy","variant-adoptables":"_1FK25","variantAdoptables":"_1FK25"};